module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/internals/perform.js
// module id = 237
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35